<template>
  <div class='CheckoutSideItem01'>
    <div class="cont-img">
      <img v-if="data.img.length" :src="api + data.img[0].img">
      <img-icon
      v-if="!data.img.length"
      :options="{ width: '50px', height: '50px', color: '#CCCCCC', action: false }"
      />
    </div>
    <div class="cont">
      <div class="desc">
        <div>{{ data.name }}</div>
        <div class="atrb">
          <label
          v-for="(a, key) in atributos"
          :key="key"
          >
            {{ a.name }}: {{ a.value }}
          </label>
        </div>
      </div>
      <div class="qtda-valor">
        <div class="qtda">
          <checkout-sideQtda01 :data="data"/>
        </div>
        <div class="valor">
          {{ preco }}
        </div>
      </div>
    </div>
    <div class="btn-delete">
      <delete-icon color="#CCCCCC" @click="DeleteCheckout01(data)"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CheckoutSideQtda01 from './CheckoutSideQtda01'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import DeleteIcon from '@/components/EnbPainel/Icons/DeleteIcon'
import api from '@/mixins/api'
export default {
  name: 'CheckoutSideItem01',
  components: { CheckoutSideQtda01, ImgIcon, DeleteIcon },
  props: ['data'],
  mixins: [api],
  computed: {
    preco () {
      if(this.data.oferta <= 0) {
        return (this.data.preco * this.data.qtda).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      }
      else {
        return (this.data.oferta * this.data.qtda).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      }
    },
    atributos () {
      return this.data.atributos.filter(a => a.values.filter(v => v.selected).length)
        .map(a => ({ name: a.name, value: a.values.filter(v => v.selected)[0].name }))
    }
  },
  methods: {
    ...mapActions(['DeleteCheckout01'])
  }
}
</script>

<style scoped>
.CheckoutSideItem01 {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 20%;
}

.cont-img {
  width: 20%;
  padding: 2%;
}

img {
  width: 40px;
  height: 40px;
}

.cont {
  width: 65%;
  height: 100%;
}

.desc {
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: left;
  font-weight: bold;
}

.atrb {
  display: flex;
  flex-wrap: wrap;
}

label {
  font-size: 10px;
  margin-right: 5px;
  font-weight: normal;
}

.qtda-valor {
  height: 50%;
  display: flex;
  justify-content: center;
}

.qtda {
  width: 50%;
  display: flex;
  align-items: center;
  
}

.valor {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
